import dayjs from "dayjs";
import { BookingDialogActionType } from "../Actions";
import { SearchActionType } from "../Search/Actions";
import { ITableBooking, ITablebookingState } from "./Model";
import { SkinetworksActionType } from "./Actions";

export const createSkinetworksreducer = (initialState: ITablebookingState = { }) => {
	return (state: ITablebookingState = initialState, action: { type: SearchActionType|BookingDialogActionType|SkinetworksActionType }) : ITablebookingState => {
		switch (action.type) {
			case "loadStopsComplete":
				return { ...state, ...{ stops: (action as any).payload.items } };
			case "setOrigin":
				return { ...state, ...{ origin: (action as any).stop }};
			case "setDestination":
				return { ...state, ...{ destination: (action as any).stop }};
			case "searchJourneyComplete":
				return { ...state, ...{ travels: (action as any).payload.offer?.travels }};
			case "setDepartureDate":
				return updateDepartureDate(state, (action as any).date);
			case "setReturnDate":
				return updateReturnDate(state, (action as any).date);
			case "setCustomerDetails":
				return { ...state, ...{ customerDetails: (action as any).customerDetails }};
			case "clearCustomerDetails":
				return { ...state, ...{ customerDetails: undefined }};
			case "loadAvailableTimesComplete":
				return { ...state, ...{ availableTimes: (action as any).payload.items }};
			case "clearAvailableTimes":
				return { ...state, ...{ availableTimes: undefined }};
			case "bookTableComplete":
				return bookTableComplete(state, (action as any));
			default:
				return state;
		}
	};
};

function updateDepartureDate(state: ITablebookingState, date?: string) : ITablebookingState
{
	if (date && dayjs().isAfter(date, "day"))
		return state;

	return { ...state, ...{ departureDate: date }};
}

function updateReturnDate(state: ITablebookingState, date?: string) : ITablebookingState
{
	if (date && state.departureDate && dayjs(date).isBefore(state.departureDate, "day"))
		return state;

	return { ...state, ...{ returnDate: date }};
}

function bookTableComplete(state: ITablebookingState, action: { meta: { travelId: string, slot: string }, payload: ITableBooking }) : ITablebookingState
{
	if (!state.travels || !state.travels.some(x => x.id === action.meta.travelId))
		return state;

	const booking = {...action.payload};
	booking.travelId = action.meta.travelId;
	booking.slot = action.meta.slot;

	const bookings = state.tableBookings ? [...state.tableBookings] : [];
	const idx = bookings.findIndex(x => x.travelId === action.meta.travelId && x.slot === action.meta.slot);
	if (idx >= 0)
		bookings[idx] = booking;
	else
		bookings.push(booking);

	return { ...state, tableBookings: bookings };
}